export default __webpack_public_path__ + "static/huangbin2-7155c134a952f0c768eb99959a347f68.jpg";